import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from '../context/GlobalContext';
import { apir } from '../lib/haxios';
import { Close, Phone } from '../design/Icons';

// Global SSE-driven screen-pop overlay. Renders nothing until the logged-in
// user's extension receives an inbound call invitation. Dismisses automatically
// when the call ends (cdr or failed event with the same call_id).
//
// The user's extension comes from uinfo.Extension if present — otherwise the
// component is inert. Backend bus emits 'inbound' with ringing_extensions[].

const IncomingCallPop = () => {
  const { uinfo } = useContext(GlobalContext);
  const nav = useNavigate();
  const [active, setActive] = useState(null); // { call_id, from_number, customer_keycode }

  // Extension is whatever the operator has bound. Falls back to localStorage
  // override for ad-hoc testing.
  const ext = uinfo?.Extension || uinfo?.extension || localStorage.getItem('userExtension');

  useEffect(() => {
    if (!ext || !apir) return;
    let src;
    try {
      // EventSource can't set an Authorization header, so the JWT rides along
      // as ?access_token= (passport bearer reads it from the query).
      const tok = localStorage.getItem('token');
      const url = `${apir}/calls/stream?extension=${encodeURIComponent(ext)}`
        + (tok ? `&access_token=${encodeURIComponent(tok)}` : '');
      src = new EventSource(url, { withCredentials: false });

      src.addEventListener('inbound', (e) => {
        try {
          const data = JSON.parse(e.data);
          setActive(data);
        } catch { /* ignore */ }
      });
      const dismiss = (e) => {
        try {
          const data = JSON.parse(e.data);
          setActive(curr => (curr && curr.call_id === data.call_id ? null : curr));
        } catch { /* ignore */ }
      };
      src.addEventListener('cdr',    dismiss);
      src.addEventListener('failed', dismiss);
      src.onerror = () => { /* EventSource auto-retries; we just stay quiet */ };
    } catch {
      // SSE unsupported / blocked — silently inert
    }
    return () => src && src.close();
  }, [ext]);

  if (!active) return null;

  return (
    <div className="incoming-pop">
      <div className="incoming-pop-head">
        <span><Phone size={12}/> Incoming call</span>
        <button type="button" className="btn ghost sm" onClick={() => setActive(null)}>
          <Close size={11}/>
        </button>
      </div>
      <div className="incoming-pop-body">
        <div className="incoming-num num">{active.from_number || 'Unknown number'}</div>
        {active.customer_keycode ? (
          <>
            <div className="label" style={{ color: 'var(--ink-3)', marginTop: 4 }}>
              Customer: <span className="num">{active.customer_keycode}</span>
            </div>
            <div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
              <button
                type="button" className="btn orange sm"
                onClick={() => { nav(`/customers?account=${encodeURIComponent(active.customer_keycode)}`); setActive(null); }}
              >
                Open customer →
              </button>
            </div>
          </>
        ) : (
          <div className="label" style={{ color: 'var(--ink-3)', marginTop: 6 }}>
            No matching customer · {active.trunk_name || 'unknown trunk'}
          </div>
        )}
      </div>
    </div>
  );
};

export default IncomingCallPop;
